import { t } from '@/utils/i18n';

export const translateError = ([errorKey, errorValue]: [string, string]) => {
  switch (errorKey) {
    case 'api':
      return errorValue;
    default:
      return t(`error.${errorKey}`, errorValue);
  }
};
